import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const connectionString = process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;

export const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: false,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
  },
});

appInsights.loadAppInsights();
